import { isAxiosError } from 'axios';
import { ApiError } from 'api';
import { ERROR_400, ERROR_500 } from 'common/config/api';
import { resetPasswordLegacyTokenPrefix, resetPasswordTokenPrefix } from 'common/config/urls';

export const normalizePasswordResetUrl = (value: string) => {
  const normalizedValue = value.startsWith('/') ? value : `/${value}`;
  return normalizedValue.replace(`${resetPasswordLegacyTokenPrefix}/`, `${resetPasswordTokenPrefix}/`);
};

export const isActivationClientError = (error: unknown) => {
  if (error instanceof ApiError) {
    return error.status >= Number(ERROR_400) && error.status < Number(ERROR_500);
  }

  return isAxiosError(error)
    && typeof error.response?.status === 'number'
    && error.response.status >= Number(ERROR_400)
    && error.response.status < Number(ERROR_500);
};
